module.exports = __webpack_public_path__ + "static/media/petadopter.b3097b41.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/petadopter.png
// module id = 478
// module chunks = 0